/**
 * 判断一个值是否为空
 * @param {*} value
 */
const isNil = (value) => value === undefined || value === null || value === '';

export default isNil;
